// extracted by mini-css-extract-plugin
export var video = "ImageAndText-module--video--lz8Ap";
export var wrapper = "ImageAndText-module--wrapper--iOklN";